import React, { useMemo, useState } from 'react';
import { useGlobalContext } from './utils/GlobalContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Header() {
  const { numbersActive, imagesActive, handleNumberClick, handleImageClick, tokenSearchVal, setTokenSearchVal, darkMode, toggleDarkMode } = useGlobalContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const { thingsActive, signalsActive, frameActive, infoActive, infoSubPage, isDetailPage } = useMemo(() => {
    const isInfoPage = location.pathname === '/info';
    const isInfoSubPage = ['/links', '/tos', '/versions', '/storage'].includes(location.pathname);
    return {
      thingsActive: location.pathname === '/',
      signalsActive: location.pathname.includes('/signals'),
      frameActive: location.pathname === '/frame',
      infoActive: isInfoPage || isInfoSubPage,
      infoSubPage: isInfoSubPage,
      isDetailPage: location.pathname.includes('/things/'),
    };
  }, [location.pathname]);

  const toggleMenu = () => {
    if (location.pathname !== '/' && !location.pathname.includes('/things/') && !location.pathname.includes('/signals')) {
      navigate('/');
    }
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <button onClick={toggleDarkMode} className="dark-mode-toggle" title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
        {darkMode ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        )}
      </button>
      <div className="header-container">
        <div className="title">
          <Link to={
            isDetailPage && location.state?.fromTrait
              ? `/?trait_type=${encodeURIComponent(location.state.fromTrait.traitType)}&trait_value=${encodeURIComponent(location.state.fromTrait.traitValue)}`
              : isDetailPage ? '/'
              : infoSubPage ? '/info'
              : infoActive ? '/'
              : location.search.includes('trait_type') ? '/'
              : '/info'
          } className="title-link">
            <span className="title-text">
              {'THINGDOMS'.split('').map((letter, index) => (
                <span key={index} className="title-letter" style={{ '--letter-index': index }}>
                  {letter}
                </span>
              ))}
            </span>
          </Link>
        </div>
        <div className="header-controls">
          {thingsActive && <>
          <div className="collection-viewer">
            <button className={`number-view ${numbersActive ? 'active' : ''}`} onClick={handleNumberClick}>#</button>
          </div>
          <div className="collection-viewer">
            <button className={`image-view ${imagesActive ? 'active' : ''}`} onClick={handleImageClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="122" height="146" viewBox="0 0 122 146" className="icon icon-image">
                <defs></defs>
                <path d="M6.71 139V7h62.52l45.48 41.52V139z" style={{ 'strokeWidth': 0, 'fill': darkMode ? '#000' : '#fff' }}></path>
                <path d="m66.52 14 41.19 37.61V132h-94V14zm5.42-14H-.29v146h122V45.43z" className="cls-1"></path>
                <path d="M65.71 0v52h56" className="cls-2"></path>
                <path d="M20.37 125h81.26v-23.02L77.8 78.15l-22.16 22.17-11.46-11.46-23.81 24.5z" className="cls-1"></path>
                <circle cx="32.49" cy="70.12" r="12.12" className="cls-1"></circle>
              </svg>
            </button>
          </div>
          <div className="collection-viewer">
            <button onClick={toggleMenu} className={isMenuOpen ? 'active' : ''}>
              <svg xmlns="http://www.w3.org/2000/svg" width="122" height="146" viewBox="0 0 122 146" className="icon icon-search">
                <path
                  d="M51.85 108.78C28.22 108.78 9 89.56 9 65.93s19.22-42.86 42.85-42.86S94.7 42.29 94.7 65.92s-19.22 42.85-42.85 42.85Z"
                  style={{ fill: '#fff', strokeWidth: 0 }}
                ></path>
                {darkMode && (
                  <circle
                    cx="51.85"
                    cy="65.93"
                    r="37"
                    style={{ fill: '#000', strokeWidth: 0 }}
                  ></circle>
                )}
                <path
                  d="M51.85 32.07c18.67 0 33.85 15.19 33.85 33.85S70.51 99.77 51.85 99.77 18 84.58 18 65.92s15.19-33.85 33.85-33.85m0-18C23.22 14.07 0 37.29 0 65.93s23.22 51.85 51.85 51.85 51.85-23.22 51.85-51.85-23.21-51.86-51.85-51.86"
                  style={{ fill: '#000', strokeWidth: 0 }}
                ></path>
                <path
                  d="m82.71 99.93 30 32"
                  style={{ stroke: darkMode ? '#fff' : '#000', strokeLinecap: 'square', strokeMiterlimit: 10, strokeWidth: '18px', fill: '#fff' }}
                ></path>
              </svg>
            </button>
          </div>
          <div className="collection-viewer nav-container">
            <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
              <ul>
                <li>
                  <input
                    type="text"
                    id="token-search-input"
                    name="token-search-input"
                    aria-label="Thing #"
                    className="token-search-input"
                    value={tokenSearchVal}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow numeric input (including empty string)
                      if (value === '' || /^\d+$/.test(value)) {
                        setTokenSearchVal(value);
                      }
                    }}
                    placeholder="Thing #"
                  />
                </li>
              </ul>
              <button className="close-menu-button" style={{ display: isMenuOpen ? 'inline-block' : 'none' }} onClick={toggleMenu}>&times;</button>
            </nav>
          </div>
          </>}
        </div>
      </div>
      <nav className={`nav-menu-mobile ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li style={{ width: '100%', marginBottom: '6px' }}>
            <input
              type="text"
              id="token-search-input-mobile"
              name="token-search-input-mobile"
              aria-label="Search Token ID"
              className="token-search-input-mobile"
              value={tokenSearchVal}
              onChange={(e) => {
                const value = e.target.value;
                // Only allow numeric input (including empty string)
                if (value === '' || /^\d+$/.test(value)) {
                  setTokenSearchVal(value);
                }
              }}
              placeholder="Search Token ID"
            />
          </li>
        </ul>
        <button className="close-menu-button" style={{ display: isMenuOpen ? 'inline-block' : 'none' }} onClick={toggleMenu}>&times;</button>
      </nav>
    </header>
  );
};
